// src/integrations/OfhIntegration.ts
import type { IntegrationInterface } from '@/interfaces/IntegrationInterface'
import { apiPostPublic } from '../util/api'

export class OfhIntegration implements IntegrationInterface {
    async login(credentials: any): Promise<any> {
        const user = credentials.user || credentials

        // If validating OTP
        if (user?.otp_code && user?.otp_token && user?.email) {
            const response = await apiPostPublic<{ data: any }>('auth/verify_otp', {
                user: {
                    email: user.email,
                    otp_code: user.otp_code,
                    otp_token: user.otp_token
                },
                integration_id: 'ofh'
            })

            return {
                headers: response.headers,
                data: response.data.data
            }
        }

        // If initial login (password only)
        const response = await apiPostPublic('auth/login', {
            user: { email: user.email, password: user.password, otp_token: user.otp_token },
            integration_id: 'ofh'
        })
        return {
            headers: response.headers,
            data: response.data
        }
    }
}
